// 处理后端来的数据
import store from '@/store'


// 通过后端来的props生成类目属性的索引表
function _genPropMapBy(props) {
  const map = {}
  props.forEach(element => {
    const needgUnit = gUnitIds.includes(`p-${element.propId}`)
    map[`p-${element.propId}`] = element.propValues.map(item => {
      if (needgUnit) {
        item.valueId = String(item.valueId).replace('g', '')
        item.valueName = String(item.valueName).replace('g', '')
      }

      // 属于多实例复合型
      if (item.valueId === "MULTICOMPLEX") {
        return {
          ...item,
          valueName: item.valueName ? JSON.parse(item.valueName) : item.valueName,
          pLabel: element.propName
        }
      }

      return {
        ...item,
        value: item.valueId,
        displayName: item.valueName,
        pLabel: element.propName
      }
    })
  })
  return map
}

// 通过后端来的sizeGroup生成尺码分组选项索引表
function _genSizeMapBy(sizeGroup) {
  const map = {}
  for (const key in sizeGroup) {
    const {groupId, groupValue} = sizeGroup[key]
    map[groupId] = groupValue
  }
  return map
}

// 将后端来的数据转为当前tjbForm需要的格式
export const data2form = (data, form) => {
  const formKeys = Object.keys(form)
  let _form = {}
  const PropMap = _genPropMapBy(data.props)
  const SizeMap = _genSizeMapBy(data.sizeGroup)
  // tjbform的key 对应后段来的数据的 key
  const formKey2dataKeyMap = {
    // "images": "images",
    "quantity": "num",
    "country": "globalStockCountry",
    "stockType": "globalStockType"
  }

  formKeys.forEach(formKey => {
    // 根据已生成的formKey，取data中对应值填入到_form中，最终返回_form
    
    if (/-sizeGroup$/.test(formKey)) {
      // 判断当前是否是尺码分组
      if (SizeMap.hasOwnProperty(formKey)) {
        _form[formKey] = SizeMap[formKey]
      }
    } else if (/^p-/.test(formKey)) {
      if (formKey === 'p-2814443') {
      }
      // 判断当前是否是类目属性
      if (PropMap.hasOwnProperty(formKey)) {
        _form[formKey] = PropMap[formKey]
      }
    } else if (['warranty', 'invoice'].includes(formKey)) {
      // 处理一些后端加上了has的字段
      let dataKey = `has${formKey[0].toUpperCase() + formKey.substr(1)}`
      _form[formKey] = String(data[dataKey])
    } else if (formKey2dataKeyMap.hasOwnProperty(formKey)) {
      // 处理一些后段数据的key与当前生成的form的key不一致的情况
      if (formKey === 'country') {
        // 地区/国家 特殊处理
        _form[formKey] = data[formKey2dataKeyMap[formKey]] ? {
          displayName: data[formKey2dataKeyMap[formKey]],
          value:  data[formKey2dataKeyMap[formKey]]
        } : _form[formKey]
      } else {
        _form[formKey] = data[formKey2dataKeyMap[formKey]] || _form[formKey]
      }
    } else {
      // 一般处理
      // 当前formKey是否存在data中，存在就赋值
      if (data.hasOwnProperty(formKey)) {
        let dataV = data[formKey]
        _form[formKey] = dataV instanceof Array ? dataV : String(dataV) === 'null' ? '' : String(dataV)
      }
    }

  })

  return _form
}

// 不聪明的解决方案，维护一个props字段中需要加上 “g” 这个单位的pid数组
const gUnitIds = ['p-216832544']

// 通过表单数据转为后端所需的props字段
export function _genPropsByForm(form) {
  const tjbForm = store.state.tjbForm.form
  let _valueId = -99 // 有些属性并没有valueId 需要自己提供负整数的valueId
  const props = []
  for(const formKey in form) {
    // 判断是否为类目属性
    if (/^p-/.test(formKey) && !/-sizeGroup$/.test(formKey)) {
      // KMERP-69064 修复会将之前的prop带入表单的问题
      if (!tjbForm.hasOwnProperty(formKey)) continue

      let value = form[formKey]
      // 过滤空值
      if (!value) continue 
      if (value instanceof Array && value.filter(item => {
        return typeof item == 'object' ? (Boolean(item.valueName) || Boolean(item.displayName)) : Boolean(item)
      }).length < 1) continue 

      const needgUnit = gUnitIds.includes(formKey)

      let propName = ''
      value = value.map(item => {
        if (!propName) propName = item.pLabel
        let _valueId = item.valueId ? item.valueId : item.value ? item.value : _valueId--
        let _valueName = item.valueName ? item.valueName : item.displayName

        if (needgUnit) {
          _valueId = String(_valueId).replace('g', '') + 'g'
          _valueName = String(_valueName).replace('g', '') + 'g'
        }

        if (_valueId === "MULTICOMPLEX") {
          _valueName = JSON.stringify(_valueName);
        }

        return {
          valueId: _valueId,
          valueName: _valueName
        }
      })

      props.push({
        propId: formKey.replace(/^p-/, ''),
        propName,
        propValues: value
      }) 

    }
  }
  return props
}

// 将当前tjbForm转为后端保存时需要的数据格式
export const form2data = (form, data) => {
  // console.log(form, '----form')
  // console.log(data, '----data')
  

  const dataKeys = Object.keys(data)
  let _data = {}
  // data的key 对应生成的form的Key
  const dataKey2formKeyMap = {
    // "itemImgs": "images",
    "num": "quantity",
    "globalStockCountry": "country",
    "globalStockType": "stockType"
  }

  dataKeys.forEach(dataKey => {
    // 根据原后端所需字段，去form中对应字段值填入_data
    if (dataKey === 'cid') {
      // 叶子类目id
      _data[dataKey] = form.categoryIds[form.categoryIds.length - 1]
    } else if (['hasInvoice', 'hasWarranty'].includes(dataKey)) {
      // 需要加上has的字段
      let formKey = dataKey.toLowerCase().replace(/^has/, '')
      _data[dataKey] = form[formKey]
    } else if (dataKey2formKeyMap.hasOwnProperty(dataKey)) {
      // 处理一些后段数据的key与当前生成的form的key不一致的情况
      if (dataKey === 'globalStockCountry') {
        // 地区/国家 特殊处理
        _data[dataKey] = form[dataKey2formKeyMap[dataKey]]?.value
      } else {
        _data[dataKey] = form[dataKey2formKeyMap[dataKey]]
      }
    } else if (dataKey === 'props') {
      // 处理类目属性
      _data[dataKey] = _genPropsByForm(form)
    } else if (['sizeGroup', 'skuList', 'specifications'].includes(dataKey)) {
      // 尺码分组、处理规格详情、处理规格信息
      // 这三个数据由Specification.vue组件的method_getData方法获取
      // 不在这里做格式化处理
      return ;
    } else if(dataKey === 'tbDeliveryTime') {
      _data[dataKey] = form[dataKey].value || ''
    } else {
      // 默认处理方式
      // form中有这个字段从form里拿，没有就沿用原data的
      _data[dataKey] = form.hasOwnProperty(dataKey) ? form[dataKey] : data[dataKey]
    }
  })


  return _data
}

// 手机端详情 --- 将表单富文本转为后端所需的xml
export const html2wapHtml = (html) => {
  // 采取dom的方式完成替换
  // <img src /> -> <img>src</img>
  // <其他>xxx</其他> -> <txt>xxx</txt>
  const div = document.createElement('div')
  div.innerHTML = `${html.replace(/<\/?wapdesc>/g, '')}`
  const nodes = div.childNodes
  let wapHtml = ''

  function format(nodes) {
    nodes.forEach(node => {
      // console.log(node)

      if (node.childNodes && node.childNodes.length) {
        format(node.childNodes)
        return ;
      }

      if (node.nodeName === '#text') {
        if (!node.textContent.trim()) return;
        wapHtml += `<txt>${node.textContent}</txt>`
      } else if (node.nodeName === 'IMG') {
        wapHtml += `<img>${node.src}</img>`
      } else {
        if (!node.innerHTML.trim()) return;
        wapHtml +=  `<txt>${node.innerHTML}</txt>`
      }

    })
  }

  format(nodes)

  return `<wapdesc>${wapHtml}</wapdesc>`
}

// 手机端详情 --- 将后端传来的xml转为表单详情中的富文本
export const wapHtml2Html = (wapHtml) => {
  let html = wapHtml.replace(/<\/?wapdesc>/g, '')

  html = html.replace('<txt>', '<p>')
  html = html.replace('</txt>', '</p>')
  html = html.replace(/<img>([^>]+)<\/img>/g, '<img src="$1" />')
  return html
}

// 对一些数据进行默认赋值
export const dataDefaultValue = (data) => {
  let _data = {
    ...data
  }
  const defaultValueMap = {
    'stuffStatus': '5',
    'globalStockNav': '0',
    'subStock': '1',
  }
  for(const key in defaultValueMap) {
    if (_data[key] === 0) {
      _data[key] = String(_data[key])
    }
    if (_data.hasOwnProperty(key) && !_data[key]) {
      _data[key] = defaultValueMap[key]
    }
  }
  return _data
}
